// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"407":"d7c0f915","436":"8929e968","453":"f394a27d","501":"60c9b200","606":"00f644ff","821":"3f841c25","925":"3f5844f9","969":"eb8e8309"}[chunkId] + ".chunk.js";
};